import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Fab, SoCelular } from '../styles'

export const FabLink: FC<{ to: string; rotulo: string }> = ({ to, rotulo }) => (
  <SoCelular>
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Fab>
        <span aria-hidden="true" style={{ fontSize: 22, lineHeight: 1 }}>+</span>
        {rotulo}
      </Fab>
    </Link>
  </SoCelular>
)
